<template>
    <el-card class="page_card account_center" ref="card" v-loading="!is_ok">
        <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick" style="height: 100%;">
            <el-tab-pane label="每日统计" name="day" style="padding: 20px 15px;overflow-y: auto;height: calc(100vh - 110px);position: relative">
                <span style="font-size: 1.2em">销售量统计(每日)</span>
                <el-divider></el-divider>
                <el-form inline ref="dayForm" :model="dayForm" :loading="is_post">
                    <el-form-item label="企业名称/简称">
                        <el-select
                            v-model="dayForm.comId"
                            :multiple="false"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入企业名称/简称"
                            @change="changeCom">
                            <el-option
                                v-for="item in componys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="dayForm.timeRange"
                            type="daterange"
                            align="right"
                            unlink-panels
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain type="primary" :loading="is_post" @click="day_select(false)">查 询</el-button>
                        <el-button plain @click="resetSelect()">重 置</el-button> 
                    </el-form-item>
                </el-form>
                <el-table stripe :data="day_data" style="" v-loading="is_loading" :max-height="tableMaxHeight" v-if="showtable"  show-summary :summary-method="getSummaries">
                    <el-table-column label="企业名称">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.companyName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日期">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.date}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="车数">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.carCount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售量(吨)" align="right">
                        <template slot-scope="scope">
                            <span class="primary_text">{{parseNums(scope.row.weight)}} 吨</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div style="height: 50px;display: flex;align-items: center;position: absolute;bottom: 43px;left: 0">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="15"
                        hide-on-single-page
                        @current-change="pageChange"
                        :total="total">
                    </el-pagination>
                </div> -->

            </el-tab-pane>
            <el-tab-pane label="每月统计" name="month" style="padding: 20px 15px;overflow-y: auto;">
                <span style="font-size: 1.2em">销售量统计(每月)</span>
                <el-divider></el-divider>
                <el-form inline ref="monthForm" :model="monthForm" :loading="is_post">
                    <!-- <el-form-item label="产品">
                        <el-select v-model="monthForm.goodsId" placeholder="请选择">
                            <el-option
                                v-for="item in goods_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="企业名称/简称">
                        <el-select
                            v-model="monthForm.comId"
                            :multiple="false"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入企业名称/简称"
                            @change="changeComMonth">
                            <el-option
                                v-for="item in componys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="monthForm.timeRange"
                            type="monthrange"
                            align="right"
                            unlink-panels
                            format="yyyy-MM"
                            value-format="yyyy-MM"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="monthPickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain type="primary" :loading="is_post" @click="month_select(false)">查 询</el-button>
                        <el-button plain @click="resetSelectMonth()">重 置</el-button>
                    </el-form-item>
                </el-form>
                <el-table stripe :data="month_data" v-loading="is_loading" :max-height="month_height" v-if="show_month_table"  show-summary :summary-method="getSummariesMonth">
                    <el-table-column label="企业名称">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.companyName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="月份">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.date}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="车数">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.carCount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售量(吨)" align="right">
                        <template slot-scope="scope">
                            <span class="primary_text">{{parseNums(scope.row.weight)}} 吨</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import moment from "moment"
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
import request from '@/utils/request'
export default {
    name: 'sales_vital',
    data(){
        return {
            is_ok:false,
            is_post:false,
            is_loading:false,
            activeName:"day",
            showtable:false,
            tableMaxHeight:0,
            month_height:0,
            show_month_table:false,
            dayPickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            monthPickerOptions:{
                shortcuts: [{
                    text: '今年',
                    onClick(picker) {
                        const end = new Date();
                        let start = moment().startOf('year').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '去年',
                    onClick(picker) {
                        const last_year = parseInt(new Date().getFullYear()) - 1;
                        const start = moment().year(last_year).month(0).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).toDate();
                        const end = moment().startOf('year').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            componys:[],
            dayForm:{
                // goodsId:0,
                comId:'',
                timeRange:[],
                pageSize:10000000,
                pageNum:1
            },
            monthForm:{
                // goodsId:0,
                comId:'',
                timeRange:[]
            },
            day_data:[],
            month_data:[],
            goods_list:[],
            total:0,
            listDayData:{},
            listMonthData:{}
        }
    },
    methods:{
        changeCom(e){
            this.dayForm.comId=e;
            this.day_select(true);
        },
        changeComMonth(e){
            this.monthForm.comId=e;
            this.month_select(true);
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
                this.componys.push( {id:"",name:"全部"})
            }).catch(err=>{
            });
        },
        resetSelect(){
            this.dayForm = {
                 comId:'',
                timeRange:[],
                pageSize:15,
                pageNum:1
            };
            this.$refs["dayForm"].resetFields();
            this.day_select(true);
        },
        resetSelectMonth(){
            this.monthForm = {
                comId:'',
                timeRange:[]
            };
            this.$refs["monthForm"].resetFields();
            this.month_select(true);
        },
        handleClick(tag,event){

        },
        pageChange(page){
            this.dayForm.pageNum = page;
            this.day_select();
        },
        day_select(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("report/stt/daily",this.dayForm).then(res=>{
                this.day_data = res.data.pageInfo.list;
                this.total = res.data.pageInfo.total;
                this.listDayData=res.data;
                if(is_init){
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.dayForm.$el.offsetHeight-115;
                    this.showtable = true;
                    this.is_ok = true;
                }else{
                    this.is_loading = false;
                    this.is_post = false;
                }
            }).catch(err=>{
                if(is_init){
                    this.is_ok = true;
                }else{
                    this.is_loading = false;
                    this.is_post = false;
                }
            });
        },
        month_select(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("report/stt/month",this.monthForm).then(res=>{
                this.month_data = res.data.monthVOList;
                this.listMonthData=res.data;
                if(is_init){
                    this.month_height = this.$refs.card.$el.offsetHeight - this.$refs.dayForm.$el.offsetHeight-110;
                    this.show_month_table = true;
                    this.is_ok = true;
                }else{
                    this.is_loading = false;
                    this.is_post = false;
                }
            }).catch(err=>{
                if(is_init){
                    this.is_ok = true;
                }else{
                    this.is_loading = false;
                    this.is_post = false;
                }
            });
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        getData(){
            request.get("goods/list?keyword=").then(res=>{
                this.goods_list = res.data;
                for(let item of res.data){
                    if(item.isMain == 1){
                        this.dayForm.goodsId = item.id;
                        this.monthForm.goodsId = item.id;
                    }else{
                        this.dayForm.goodsId = res.data[0].id;
                        this.monthForm.goodsId = res.data[0].id;
                    }
                }
                this.day_select(true);
                this.month_select(true);
            }).catch(err=>{
                console.log(err);
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }else if(index === 2){
                    sums[index] = this.listDayData.totalCarCount;
                    return;
                }else if(index === 3){
                    sums[index] = this.listDayData.totalWeight+'吨';
                    return;
                }else if(index === 4){
                    sums[index] = this.listDayData.totalAmount+'万';
                    return;
                }else if(index === 5){
                    sums[index] = this.listDayData.price+'元/吨';
                    return;
                }
            });
            return sums;
        },
        getSummariesMonth(param) {
           const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }else if(index === 2){
                    sums[index] = this.listMonthData.totalCarCount;
                    return;
                }else if(index === 3){
                    sums[index] = this.listMonthData.totalWeight+'吨';
                    return;
                }else if(index === 4){
                    sums[index] = this.listMonthData.totalAmount+'万';
                    return;
                }else if(index === 5){
                    sums[index] = this.listMonthData.price+'元/吨';
                    return;
                }
            });
            return sums;
        },
    },
    created() {
        this.getCompany();
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
        this.getData();
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
